// extracted by mini-css-extract-plugin
export default {"overlay":"SideBar_overlay__7gJTa","container":"SideBar_container__5LujC","list":"SideBar_list__XTQ92"};